<template>
  <div class="container-fluid bg-moon-dust p-3">
    <div class="container bg-light py-3 rounded border shadow-sm mb-3">
      <div class="fw-bold fs-1 mb-3 title-font">OSU GRAD ADVANTAGE</div>
      <div class="row">
        <div class="col-12 col-sm-12 col-lg-4 mb-3">
          <TableOfContents :questionData="getQuestionData" />
        </div>
        <div class="col">
          <div v-if="!getCurrentQuestion">
            <IntroductionComponent />
          </div>
          <div
            v-else-if="getCurrentQuestion === 'Summary' || getSurveyComplete"
          >
            <SurveySummary />
          </div>
          <div v-else>
            <CurrentContentContainer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableOfContents from "@/components/TableOfContents.vue";
import CurrentContentContainer from "@/components/CurrentContentContainer.vue";
import SurveySummary from "@/components/SurveySummary.vue";
import IntroductionComponent from "@/components/IntroductionComponent.vue";
import { mapGetters, mapActions } from "vuex";
import { v4 as uuid } from "uuid";

export default {
  name: "ActivityView",
  components: {
    IntroductionComponent,
    TableOfContents,
    CurrentContentContainer,
    SurveySummary
  },
  props: {},
  computed: {
    ...mapGetters([
      "getQuestionData",
      "getCurrentQuestion",
      "getSurveyComplete"
    ])
  },
  methods: {
    ...mapActions([
      "fetchQuestionData",
      "fetchRecommendationData",
      "setSessionId"
    ]),
    initializeSession() {
      let sessionId = localStorage.getItem("sessionId");
      if (!sessionId) {
        sessionId = uuid();
        localStorage.setItem("sessionId", sessionId);
      }
      this.setSessionId(sessionId);
    }
  },
  created() {
    this.fetchQuestionData();
    this.fetchRecommendationData();
    this.initializeSession();
  },
  mounted() {},
  watch: {
    getQuestionData: {
      handler(newVal) {
        if (newVal) {
          console.log(this.getQuestionData);
        }
      },
      deep: true
    }
  }
};
</script>
